import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-drivers',
  templateUrl: './drivers.component.html',
  styleUrls: ['./drivers.component.css']
})
export class DriversComponent extends BaseCrudComponent {

  	translations:any;
    orders:any;
    drivers:any;
    loadingRequired:any;
    status:any;
    doctypes:any;
    users:any;
    groups:any;

  	constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
      ) {
        super(srv, modalService, storage, router);

        this.read_url = 'LogisticDriver/All';
        this.create_url = 'LogisticDriver/Create';
        this.update_url = 'LogisticDriver/Update';
        this.delete_url = 'LogisticDriver/LogicalDelete';
        this.search_fields = ['name','driver','status'];
        this.loadingRequired = false;
        this.doctypes = [];
        this.users = [];
        this.groups = [];

        this.reload.subscribe(val => {
            if( val ){
                super.clearData();
                this.getList();
            }
        });
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
        }
        return true;
    }
    
    getList(){
      this.clearData();
      this.loadingList=true;
      this.srv.getCall(this.read_url).subscribe(x => {
          var data = x.data;
          this.loadingList=false;
          if(x.status){
            this.rows = data;
          }
        }),
        //timeout(MAX_TIME),
        catchError(data => {return of(false)})
      
    }

    public getFiltersData(){
        var par_url = 'SystemParameter/GetByName/DOC_TYPE';
        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    public getUsersData(){
        var par_url = 'User/All';
        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    public getGroupsData(){
        var par_url = 'SystemParameter/GetByName/DRIVER_GROUP';
        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    openCreateModal(content:any){
        this.c_obj = {};
        super.openCreateModal(content);
        this.loadingRequired = true;
        this.getFiltersData().subscribe(r => {
            //this.loadingRequired = false;
            if( r != false ){
                this.doctypes = r[0];
            }

            this.getUsersData().subscribe(u => {
                this.loadingRequired = false;
                if( u != false ){
                    this.users = u;
                }

                /*this.getGroupsData().subscribe(g => {
                    this.loadingRequired = false;
                    if( g != false ){
                        this.groups = g[0];
                    }
                });*/
            });
        });
    }

    openUpdateModal(content:any, obj:any){
        this.u_obj = obj;
        
        this.u_obj.licenseExpiration=this.dataConversion(obj.licenseExpiration);
        super.openCreateModalLG(content);
        this.loadingRequired = true;
        this.getFiltersData().subscribe(r => {
            //this.loadingRequired = false;
            if( r != false ){
                this.doctypes = r[0];
            }

            this.getUsersData().subscribe(u => {
                this.loadingRequired = false;
                if( u != false ){
                    this.users = u;
                }

                /*this.getGroupsData().subscribe(g => {
                    this.loadingRequired = false;
                    if( g != false ){
                        this.groups = g[0];
                    }
                });*/
            });
        });
    }

    dataConversion(value :String){
        console.log(value);
        if(value!=null){
            let arrParam = value.split("T");
            if(arrParam.length>0)
                return arrParam[0];
            return value;
        }
        return "";
    }

    validateCreateInfo(fields:any){
        
        let mygroup:any = {};
        mygroup = new FormGroup({
            'name': new FormControl(fields.name, [Validators.required]),
            'docType': new FormControl(fields.docType, [Validators.required]),
            'documentNumber': new FormControl(fields.documentNumber, [Validators.required]),
            'license': new FormControl(fields.license, [Validators.required]),
            'contact': new FormControl(fields.contact, [Validators.required]),
            'userId': new FormControl(fields.userId, [Validators.required])
            //'groupId': new FormControl(fields.groupId, [Validators.required])
            /*'email': new FormControl(fields.email, [Validators.required, Validators.email])*/
        });

        return mygroup.valid;
    }

    idNumberValidator(cedula){
        var cad = cedula;
        var total = 0;
        var longitud = cad.length;
        var longcheck = longitud - 1;
        
        if (cad !== "" && longitud === 10){
            for(let i = 0; i < longcheck; i++){
                if (i%2 === 0) {
                    var aux = cad.charAt(i) * 2;
                    if (aux > 9) aux -= 9;
                    total += aux;
                } else {
                    total += parseInt(cad.charAt(i)); // parseInt o concatenará en lugar de sumar
                }
            }

            total = total % 10 ? 10 - total % 10 : 0;

            if (cad.charAt(longitud-1) == total) {
                console.log("cedula correcta");
                return true;
            }else{
                console.log("cedula incorrecta");
                return false;
            }
        }else if(cad != "" && longitud === 13){//verifica si es ruc

            longcheck = longitud - 4;
            for(let i = 0; i < longcheck; i++){
                if (i%2 === 0) {
                    var aux = cad.charAt(i) * 2;
                    if (aux > 9) aux -= 9;
                    total += aux;
                } else {
                    total += parseInt(cad.charAt(i)); // parseInt o concatenará en lugar de sumar
                }
            }
    
            total = total % 10 ? 10 - total % 10 : 0;
            if (cad.charAt(longitud-4) == total) {
                console.log("cedula correcta");
                return (cedula.endsWith('001'));
            }else{
                console.log("cedula incorrecta");
                return false;
            }
        }
          
    }

    public createItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        if(!this.idNumberValidator(form.documentNumber)){
            Swal.fire("Identificacion ingresado no es el correcto", '', 'error');
            return;
        }

        var to:any;
        to = form;

        var qst = this.create_url;
        this.isCreating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isCreating = false;
            if(x.status){
                this.c_obj = {};
                this.getList();
                this.closeModal(content);
                Swal.fire('Creado', '', 'success');
            }//end success
            else{
                //Swal.fire(this.translations[x.msg], '', 'error');
                Swal.fire(x.message, '', 'error');
            }
        });
    }

    public updateItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }
        if(!this.idNumberValidator(form.documentNumber)){
            Swal.fire("Identificacion ingresado no es el correcto", '', 'error');
            return;
        }

        var to:any;
        to = form;

        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if(x.status){
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else{
                Swal.fire(x.message, '', 'error');
              //this.closeModal(content);
            }
        });
    }

}
